import { UserSignaling } from "../net/userSignaling";
import { BaseController } from "./base.controller";

const $ = require('jquery');
const catlabremote = require('catlab-remote-client');
const Webremote = catlabremote.Webremote;

export class PlayerController extends BaseController {
	async initialize(token: string) {

		Webremote.headless({
			serverlist : 'https://remote-serverlist.catlab.eu/servers.json',
		}).then(() => {

			// listen for keyboard events
			this.initKeyboardListener();

			const connection = Webremote.connect(token);
			connection.then(() => {
					
				window.onbeforeunload = function(){
					return 'Are you sure you want to leave?';
				};

				this.signaling = new UserSignaling(Webremote, (msg) => {
					this.onMessage(msg);
				});


			});

			connection.fail((error) => {
				console.error('Error connecting to server.', error);
			});

		});

		$(document).click(() => {
			if (!document.fullscreenElement) {
				document.documentElement.requestFullscreen();
			  } else if (document.exitFullscreen) {
				document.exitFullscreen();
			  }
		});

	}

	async onPeerConnect() {

		console.log('on peer connection');

		// Add our local streams to the connection
		await Promise.all([
			this.startStream('user', false),
			this.startStream('environment', true)
		]);
	}

	async startStream(facingMode: string, visible: boolean) {

	
		let video;
		if (visible) {
			video = document.createElement('video');
			video.className = 'player-camera';
			$('#root').append(video);
		}

		// Request user media
		let stream = await navigator.mediaDevices.getUserMedia({
			video: {
				facingMode: facingMode
			}
		});

		// Add stream to peer connection
		stream.getTracks().forEach((track) => {

			if (track.kind === 'audio') {
				return;
			}

			console.log('Adding track', track);
			this.pc.addTrack(track, stream);
		});

		// Show video
		if (video) {
			video.srcObject = stream;
			video.play();
		}

	}

	protected initKeyboardListener() {

		// Draw a cross of 4 icons and one in the middle

		const moveGrid = $(`<div class="icon-grid" id="move-grid">
			<div class="grid-top" data-key="move-forward">⬆</div>
			<div class="grid-left" data-key="move-left">↶</div>
			<div class="grid-center">👣</div>
			<div class="grid-right" data-key="move-right">↷</div>
			<div class="grid-bottom" data-key="move-backward">⬇</div>
			</div>`);

		$('#root').append(moveGrid);

		const watchGrid = $(`<div class="icon-grid" id="watch-grid">
			<div class="grid-top" data-key="look-up">👆</div>
			<div class="grid-left" data-key="look-left">👈</div>
			<div class="grid-center">🤳</div>
			<div class="grid-right" data-key="look-right">👉</div>
			<div class="grid-bottom" data-key="look-down">👇</div>
			</div>`);

		$('#root').append(watchGrid);

		Webremote.userEvents.on('people-command:key-down', (msg) => {
			const key = msg.key;
			$('[data-key=' + key + ']').addClass('active');
		});

		Webremote.userEvents.on('people-command:key-up', (msg) => {
			const key = msg.key;
			$('[data-key=' + key + ']').removeClass('active');
		});

	}

}

